import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-wide ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}>
              亚洲天堂
            </span>
            <span className={`hidden md:inline text-xs px-2 py-0.5 rounded-full border ${
              scrolled || !isHome ? 'text-primary-600 border-primary-300 bg-primary-50' : 'text-white/90 border-white/40'
            }`}>
              ASIA PARADISE
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'
              } ${location.pathname === '/' ? (scrolled || !isHome ? 'text-primary-600' : 'text-white') : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/southeast-asia"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'
              } ${location.pathname.startsWith('/category') ? (scrolled || !isHome ? 'text-primary-600' : 'text-white') : ''}`}
            >
              目的地
            </Link>
            <Link
              to="/category/southeast-asia"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'
              }`}
            >
              旅行攻略
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'
              } ${location.pathname === '/about' ? (scrolled || !isHome ? 'text-primary-600' : 'text-white') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:block">
            <Link
              to="/category/southeast-asia"
              className={`inline-flex items-center px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white border border-white/40 hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              探索目的地
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="flex flex-col px-4 py-4 gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">首页</Link>
            <Link to="/category/southeast-asia" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">目的地</Link>
            <Link to="/category/southeast-asia" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">旅行攻略</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-800 py-2 cursor-pointer">关于我们</Link>
            <Link
              to="/category/southeast-asia"
              className="inline-flex items-center justify-center px-5 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-white cursor-pointer mt-2"
            >
              探索目的地
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}